import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    CURRENT_USER_REQUEST,
    CURRENT_USER_SUCCESS,
    CURRENT_USER_FAIL,
    IMPERSONATE_SUCCESS,
    IMPERSONATE_FAIL,
} from '../constants/action-types';

const initialState = {
    isLoggedIn: false,
    isAdmin: false,
    isSuperUser: false,
    fetching: false,
    id: '',
    error: '',
    userInfo: {}    
}

export default function user(state = initialState, action) {    

    switch (action.type) {
        case LOGIN_REQUEST:
        case CURRENT_USER_REQUEST:
            return {
                ...state,
                fetching: true,
            }
        case LOGIN_SUCCESS:
        case CURRENT_USER_SUCCESS:
        case IMPERSONATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                isSuperUser: !!action.payload.is_superuser,
                isAdmin: !!action.payload.is_admin,
                isImpersonating: !!action.payload.is_impersonating,
                id: action.payload.id,
                fetching: false,
                error: '',
                userInfo: action.payload                  
            }
        case LOGIN_FAIL:
        case CURRENT_USER_FAIL:
        case IMPERSONATE_FAIL:
            return {
                ...initialState,
                error: action.error || ''
            }
        case LOGOUT:
            return {
                ...initialState
            }
        default:
            return state;
  }

}



// WEBPACK FOOTER //
// ./source/reducers/user.js